module.exports = __webpack_public_path__ + "static/media/largePeople.e8040bb5.svg";